<template>
<div id="wrapper">
     <nav class="menu-area">
      <ConnnectStatus />
      <h2 class="menu-area-title">{{$t("app.dashboard.sidemenu.group")}}
        <a class="icon-btn" @click="newGroup.modalActive = true"><i class="fas fa-plus"></i></a>
      </h2>
      <dl class="group-list">
        <div v-for="GroupID in joinedGroupsSortByName" v-bind:key="GroupID">
          <dt v-bind:class="{open: isListOpen(GroupID)}" @click="resetSideActive(); selectGroup(GroupID)">{{joinedGroups[GroupID]}}</dt>
          <dd>
            <ul class="group-list-menu">
              <li v-bind:class="{'active': isSideActive[0]}"><router-link :to="`/dashboard/group/${groupId}/variables`">{{$t("app.dashboard.sidemenu.variable")}}</router-link></li>
              <li v-bind:class="{'active': isSideActive[1]}"><router-link :to="`/dashboard/group/${groupId}/members`">{{$t("app.dashboard.sidemenu.member")}}</router-link></li>
              <li v-bind:class="{'active': isSideActive[2]}"><router-link :to="`/dashboard/group/${groupId}/setting`">{{$t("app.dashboard.sidemenu.setting")}}</router-link></li>
            </ul>
          </dd>
        </div>
      </dl>
      <ul class="menu-area-btn-list">
        <li class="makecode"><a>{{$t("footer.makecode")}}</a></li>
        <p><a href="http://tfab.jp/connect-b" target="_blank">{{$t("footer.extensions")}}</a></p>
        <p><a href="https://makecode.microbit.org/" target="_blank">{{$t("footer.home")}}</a></p>
        <li v-if="isJapanese"><a href="https://beta.tfabconnect.com/document.html" target="_blank">{{$t("footer.help")}}</a></li>
        <li v-if="isEnglish"><a href="https://beta.tfabconnect.com/en/document.html" target="_blank">{{$t("footer.help")}}</a></li>
        <li v-if="isJapanese"><a href="https://docs.google.com/forms/d/e/1FAIpQLSdvDLpypUmPpV-MF8p9zXWpTCpk452OoJOwzbs-lr6_ykim_A/viewform" target="_blank">{{$t("footer.opinion")}}</a></li>
        <li v-if="isEnglish"><a href="https://docs.google.com/forms/d/e/1FAIpQLSdHN17lHwtIXm4SxSVmHutudgGk0Fccrg0k9pVZcJDPeavEQw/viewform" target="_blank">{{$t("footer.opinion")}}</a></li>
        <li v-if="isJapanese"><a href="https://tfabworks.com/" target="_blank">{{$t("footer.brand")}}</a></li>
        <li v-if="isEnglish"><a href="https://tfabworks.com/en/" target="_blank">{{$t("footer.brand")}}</a></li>
      </ul>
    </nav>
    <b-modal :active.sync="newGroup.modalActive">
      <div class="popup-add-group">
        <ul class="group-popup-menu-tab">
          <li :class="{active: tabstate}"><a @click="tabstate=!tabstate; t1_focus()">{{$t('app.dashboard.sidemenu.plus.creategroup')}}</a></li>
          <li :class="{active: !tabstate}"><a @click="tabstate=!tabstate; t2_focus()">{{$t('app.dashboard.sidemenu.plus.joingroup')}}</a></li>
        </ul>

        <div v-if="tabstate" class="group-popup-content">
          <h3 class="input-title">{{$t('app.dashboard.sidemenu.plus.name')}}</h3>
          <!--
          <div class="input-box"><b-input ref="target1" maxlength="16" :pattern="pattern" v-model="newGroup.name" :validation-message="$t('error.validation')" /><button @click="registerGroup(newGroup)">{{$t('app.dashboard.sidemenu.plus.create')}}</button></div>
          -->
          <div class="input-box">
            <b-input ref="target1" maxlength="16" :pattern="pattern" v-model="newGroup.name"/>
            <button :disabled="!validation" @click="registerGroup(newGroup)">{{$t('app.dashboard.sidemenu.plus.create')}}</button>
          </div>
          <font size="1">{{$t('app.dashboard.validation_message')}}</font>
        </div>
        <div v-else class="group-popup-content">
          <h3 class="input-title">{{$t('app.dashboard.sidemenu.plus.groupconnecttoken')}}</h3>
          <div class="input-box">
            <b-input ref="target2" maxlength="6" v-model="newGroup.joinNumber" :pattern="patternDigit"/>
            <button :disabled="!validationDigit" @click="joinGroup(newGroup.joinNumber)">{{$t('app.dashboard.sidemenu.plus.join')}}</button>
          </div>
          <font size="1">{{$t('app.dashboard.validation_message_token')}}</font>
        </div>
      </div>
    </b-modal>
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="false"></b-loading>
</div>
</template>

<script>
import {mapState, mapGetters, mapActions} from 'vuex'
import ConnnectStatus from './DashboardSideMenuStatus'

export default {
    components: {
        ConnnectStatus
    },
    data() {
      let sideActive = [1, 0, 0]
      if(this.$route.path.match("/graph/") || this.$route.path.match("/variables") || this.$route.path == "/dashboard/"){
        sideActive = [1, 0, 0]
      }else if(this.$route.path.match("/members")){
        sideActive = [0, 1, 0]
      }else if(this.$route.path.match("/setting")){
        sideActive = [0, 0, 1]
      }
      return {
          newGroup: {
              tabState: 1,
              isPublic: "Private",
              modalActive: false,
              name: "",
              joinNumber: null
          },
          tabstate: true,
          isSideActive: sideActive,
          isLoading: false,
          isFirefox: window.navigator.userAgent.includes("Firefox"),
          pattern: this.isFirefox? "^[A-Za-z0-9-_@\\/][A-Za-z0-9-_@ \\/]*$" : "^[0-9-_@\\/\\p{General_Category=Letter}\\p{Emoji}][0-9-_@ \\/\\p{General_Category=Letter}\\p{Emoji}]*$", // 先頭文字はSpace除く
          patternDigit: "^\\d{6}$",
      }
    },
    computed: {
        validation: function() {
            return RegExp(this.pattern, "u").test(this.newGroup.name)
        },
        validationDigit: function() {
            return RegExp(this.patternDigit, "u").test(this.newGroup.joinNumber)
        },
        isListOpen() {
            return (id) => id === this.$store.state.groups.selected
        },
        ...mapState({
          groupId: state => state.groups.selected,
          joinedGroups: state => state.groups.joinedGroups
        }),
        ...mapGetters({
          isJapanese: 'preferences/isJapanese',
          isEnglish: 'preferences/isEnglish',
          joinedGroupsSortByName: 'groups/joinedGroupsSortByName'
        })
    },
    mounted() {
      this.changeisSideActive()
      this.$store.watch(
        (state) => state.dashboard.options.isSideActive,
        (isSideActive) => this.isSideActive = isSideActive
      )
    },
    watch: {
      '$route': function (to, from) {
        if (to.path !== from.path) {
          this.changeisSideActive()
        }
      },
      newGroup: {
        handler: function () {
          if(this.newGroup.modalActive == true){
            if(this.tabstate == true){
              this.t1_focus()
            }else{
              this.t2_focus()
            }
          }
        },
        deep: true
      }
    },
    methods:{
        t1_focus(){
          this.$nextTick(() => this.$refs.target1.focus())
        },
        t2_focus(){
          this.$nextTick(() => this.$refs.target2.focus())
        },
        registerGroup(opts) {
            this.isLoading = true
            this.registerGroup_(opts.name)
            .catch(() => { 
              this.$buefy.toast.open({
                duration: 7000,
                message: this.$t('app.dashboard.graph.error_warning'),
                position: "is-top",
                type: "is-danger"
              })
              return Promise.resolve()
            })
            .finally(() => this.isLoading = false)
            this.modalReset()
        },
        joinGroup(num) {
            this.isLoading = true
            this.joinGroup_(num)
            .catch(() => { 
              this.$buefy.toast.open({
                duration: 7000,
                message: this.$t('app.dashboard.graph.error_warning'),
                position: "is-top",
                type: "is-danger"
              })
              return Promise.resolve()
            })
            .finally(() => this.isLoading = false)
            this.modalReset()
        },
        selectGroup(grpID) {
          this.selectGroup_(grpID)
          .then(() => {
            if (this.$route.path !== '/dashboard')
              this.$router.push({path:'/dashboard',query:{...this.$route.query}}, () => {})
          })
          .catch(() => { 
            this.$buefy.toast.open({
              duration: 7000,
              message: this.$t('app.dashboard.graph.error_warning'),
              position: "is-top",
              type: "is-danger"
            })
            return Promise.resolve()
          })
        },
        modalReset() {
          this.newGroup = {
            tabState: 1,
            isPublic: "Private",
            modalActive: false,
            name: "",
            joinNumber: null
          }
        },
        changeisSideActive(){
          if(this.$route.path.match("/graph/") || this.$route.path.match("/variables") || this.$route.path == "/dashboard/"){
            this.$store.dispatch("UpdateisSideActive", [1, 0, 0])
          }else if(this.$route.path.match("/members")){
            this.$store.dispatch("UpdateisSideActive", [0, 1, 0])
          }else if(this.$route.path.match("/setting")){
            this.$store.dispatch("UpdateisSideActive", [0, 0, 1])
          }
        },
        resetSideActive(){
          this.$store.dispatch("UpdateisSideActive", [1, 0, 0])
          this.$store.dispatch('UpdateSideCangeFlag', !this.$store.state.dashboard.options.sidechangeflag)
        },
        ...mapActions({
          selectGroup_: 'groups/selectGroup',
          registerGroup_: 'groups/registerGroup',
          joinGroup_: 'groups/joinGroup',
          UpdateisSideActive: 'dashboard/UpdateisSideActive'
        })
    }
}
</script>
<style scoped>
#wrapper {
  background: #2c6ac4;
}
.menu-area {
  width: 220px;
  padding: 20px 15px;
  min-height: calc(100vh - 50px);
  background: #2c6ac4;
}
.menu-area-title {
  color: #fff;
  font-size: 1.25rem;
  font-weight: bold;
  margin: 0 0 15px 0;
}
.menu-area-title:nth-of-type(2) {
  margin: 40px 0 15px 0;
}
.menu-area-title .icon-btn {
  position: relative;
  display: inline-block;
  width: 25px;
  height: 25px;
  line-height: 25px;
  vertical-align: middle;
  text-align: center;
  border-radius: 4px;
  font-size: 0.875rem;
  background: #f3f3f3;
  color: #333;
}
.menu-area-title .icon-btn:first-of-type {
  margin: 0 8px 0 20px;
}
.group-list {
  color: #fff;
  margin-bottom: 50px;
}
.group-list dt {
  position: relative;
  margin-top: .8em;
  padding-left: 20px;
  cursor: pointer;
}
.group-list dt:before {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  font-size: 1.25rem;
  font-family: 'Font Awesome 5 Free';
  content: "\f0da";
  font-weight: 900;
}
.group-list dt.open:before {
  font-family: 'Font Awesome 5 Free';
  content: "\f0d7";
  font-weight: 900;
}
.group-list dt.open + dd {
  display: block;
}
.group-list dd {
  display: none;
  margin-top: 10px;
}
.group-list-menu li {
  padding-left: 20px;
}
.group-list-menu li a {
  display: block;
  width: 100%;
  padding: 8px 15px;
  color: #fff;
  text-decoration: none;
  letter-spacing: .05em;
}
.group-list-menu li.active a {
  color: #fff;
  border-radius: 4px;
  background: #23539a;
}
.menu-area-btn-list li {
  padding-left: 25px;
  margin-top: 20px;
  background-image: url("../../../public/img/icon-sprite.png");
  background-repeat: no-repeat;
}
.menu-area-btn-list li:nth-of-type(2) {
  background-position: 0 -15px;
}
.menu-area-btn-list li:nth-of-type(3) {
  background-position: 0 -30px;
}
.menu-area-btn-list li:nth-of-type(4) {
  background-position: 0 -45px;
}
.menu-area-btn-list li a {
  display: block;
  color: #fff;
  text-decoration: none;
}
.menu-area-btn-list li a i {
  margin-right: 10px;
}
.menu-area-btn-list p {
  margin: 5px 0px;
}
.menu-area-btn-list p a {
  margin: 0px 20px 0px 35px;
  color: #fff;
  letter-spacing: .05em;
}
.popup-add-group {
  position: fixed;
  width: 500px;
  padding: 0 0 40px 0;
  z-index: 20;
  background: #fff;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
}
.group-popup-menu-tab {
  display: flex;
  width: 100%;
}
.group-popup-menu-tab li {
  width: 50%;
}
.group-popup-menu-tab li a {
  display: block;
  padding: 15px;
  width: 100%;
  height: 100%;
  background: #2c6ac4;
  color: #fff;
  text-decoration: none;
  text-align: center;
  letter-spacing: .05em;
}
.group-popup-menu-tab li.active a {
  color: #333;
  background: #fff;
  font-weight: bold;
}

.group-popup-content {
  display: block;
  padding: 30px 30px 0 30px;
}
.input-box {
  display: flex;
  justify-content: space-between;
}
.input-box input {
  width: calc(100% - 10px);
  height: 40px;
  padding: 0 10px;
  font-size: 0.9375rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.input-box button {
  width: 100px;
  height: 40px;
  padding: 0 10px;
  background: #f5f5f5;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 0.9375rem;
  cursor: pointer;
}
.input-box button i {
  margin-right: .3em;
}
.input-box button:hover {
  opacity: .7;
}

.input-title {
  display: block;
  margin-bottom: 8px;
  font-size: 1.125rem;
  font-weight: bold;
}
.makecode {
  color: #fff !important;
}
.makecode.active {
  color: #fff !important;
}
.makecode.active a {
  color: #fff !important;
}
.makecode a {
  cursor: default;
}
</style>
